/* ============================================================================
   ATHLO+ — Shoe Lab retail-partner stock map
   ----------------------------------------------------------------------------
   Maps our shoe id -> the partner's product handle, so the Shoe Lab's
   "Where to buy" row links to the real product page instead of a search.
   Built 2026-08-22 against iRUN Singapore's public catalogue
   (irunsg.com/products.json — 1733 shoe products, 2768 total), then extended twice the same day as iRUN's
   current range was researched into assets/hub-shoes.js (104 models total).

   MATCHING RULE, because a wrong product link is worse than a search link:
   same brand, identical generation numbers, one title's tokens contained in
   the other's, AND identical presence of differentiating words (pro, elite,
   plus, premium, gts, trail, ekiden, sl...). That last clause is why "Adizero
   Adios 4" is absent here rather than pointing at "Adios Pro 4" — a different
   shoe that containment alone happily matched.

   Anything not listed falls back to the partner's search URL, which is the
   honest default: absence here means the partner did not stock it at build
   time, and stock moves.

   PRUNED 2026-10-17: every handle was re-checked at irunsg.com/products/<h>.js
   and the 8 that 404'd were removed (9 ids, streakfly is listed twice):
   adios-9, pro-evo-1, magic-speed-4, novablast-4, hyperion-max-2, clifton-9,
   streakfly, guide-17. No replacement handle was guessed; those shoes fall
   back to search. A dead handle is worse than no handle: it sends people to a 404.

   DELIBERATELY NO PRICES OR STOCK COUNTS. Both were in the same feed and both
   go stale within days; a tool that promises "measured. No spin." must not
   print a number it cannot keep true.

   Additive and removable: delete this file plus its loader line in
   sections/hub-shoe-lab.liquid and every shoe falls back to search.
   ========================================================================== */
window.HUB_PARTNER_STOCK = {
  "adidas-adios-pro-4": "adidas-adizero-adios-pro-4-womens-tactile-green",
  "adidas-adizero-avanti": "adidas-adizero-avanti-tyo-mens-gy8418",
  "adidas-ambition": "adidas-mens-womens-adizero-ambition-coreblack-gy8401",
  "adidas-avanti-tyo": "adidas-adizero-avanti-tyo-mens-gy8418",
  "adidas-boston-12": "adidas-adizero-boston12-womens-id7248",
  "adidas-boston-13": "adidas-adizero-boston-13-mens-dash-grey-flash-aqua",
  "adidas-distancestar": "adidas-adizero-distancestar-cloudwhite-lucidorange-jq0627",
  "adidas-evo-sl": "adidas-adizero-evo-sl-mens-white-tint-clear-grey",
  "adidas-finesse": "adizero-finesse-for-unisex",
  "adidas-hyperboost-edge": "adidas-hyperboost-edge-for-men",
  "adidas-prime-x-2": "adizero-prime-x-2-s-ih5685",
  "adidas-prime-x3-strung": "adizero-prime-x3-strung-cloudwhite-lucidred-jp9192",
  "adidas-pro-evo-2": "adidas-men-adizero-adios-pro-evo2-cloudwhite-jr7260",
  "adidas-pureboost-5": "pureboost-5-mens-white-prelovedink-jh6443",
  "adidas-sprintstar-2": "adidas-adizero-sprintstar-cloudwhite-lucidorange-jq0626",
  "adidas-supernova-rise-2": "adidas-supernova-rise2-womens-prelovedink-jr7688",
  "adidas-supernova-solution": "adidas-supernova-solution-mens-id3602",
  "adidas-takumi-sen-10": "adizero-takumi-sen-mens-lucidlemon-ih5707",
  "adidas-takumi-sen-11": "adidas-womens-adizero-takumi-sen10-cloudwhite-jq2818",
  "adidas-ultraboost-5": "adidas-ultraboost-5-women-id8847",
  "adidas-ultraboost-5x": "ultraboost-5x-women-cloudwhite-glowblue-yellow-ih4006",
  "altra-escalante-5": "altra-escalante-5-for-women",
  "altra-experience-flow-3": "altra-experience-flow-3-for-women",
  "altra-torin-9": "altra-torin-9-for-men",
  "altra-torin-st": "altra-torin-st-for-women",
  "asics-cumulus-26": "asics-gelcumulus26-women-1012b599-501",
  "asics-cumulus-27": "asics-mens-gelcumulus27-pureaqua-white-1012b772-300",
  "asics-gel-kayano-32": "asics-gel-kayano-32-for-women",
  "asics-gel-kayano-33": "asics-gel-kayano-33-standard-d-for-men",
  "asics-gel-nimbus-28": "asics-gel-nimbus-28-wide-d-for-women",
  "asics-gel-sonoma-8": "asics-gel-sonoma-8-standard-b-for-women",
  "asics-gt-1000-14": "asics-gt-1000-14-womens-cloud-grey-white",
  "asics-gt-2000-13": "asics-gt200013-mens-1011b861-022",
  "asics-gt-2000-14": "asics-gt-2000-14-mens-black-cobalt-burst",
  "asics-gt-2000-15": "asics-gt-2000-15-womens-hazy-lilac-taro-purple",
  "asics-gt-4000-4": "asics-gt-4000-4-wide-mens-black-light-orange",
  "asics-kayano-31": "gel-kayano-31-illuminate-mint-pure-silver-1012b671-401",
  "asics-magic-speed-5": "asics-magic-speed-5-for-unisex",
  "asics-megablast": "asics-megablast-for-men",
  "asics-metaspeed-edge-tokyo": "asics-metaspeed-edge-tokyo-for-unisex",
  "asics-metaspeed-sky-paris": "asics-womens-mens-metaspeed-sky-paris-illuminatemint-1013a123-400",
  "asics-metaspeed-sky-tokyo": "asics-metaspeed-sky-tokyo-for-unisex",
  "asics-nimbus-26": "asics-gelnimbus-men-shoes-birch-1011b794-102",
  "asics-nimbus-27": "asics-men-gel-nimbus-27-black-darkcobalt-1011b958-006",
  "asics-novablast-5": "asics-novablast-5-mens-sky-lemon-spark",
  "asics-novablast-6": "asics-novablast-6-wide-2e-for-men",
  "asics-sonicblast": "asics-sonicblast-womens-lilachint-white-1012b862-020",
  "asics-sonicsprint-elite-2": "asics-sonicsprint-elite-2-track-field-diva-pink-white-1093a031-702",
  "asics-superblast-2": "asics-superblast-2-blue-fade-edo-purple-1013a142-401",
  "asics-superblast-3": "asics-superblast-3-for-unisex",
  "brooks-adrenaline-gts-24": "brooks-men-adrenaline-gts24-black-countryblue-1104371d076",
  "brooks-adrenaline-gts-25": "brooks-adrenaline-gts-25-womens-spellbound-yucca",
  "brooks-ghost-16": "brooks-womens-ghost16-blueribbon-1204071b471",
  "brooks-ghost-17": "brooks-ghost-17-womens-poppy-seed-pink",
  "brooks-ghost-max-2": "brooks-mens-ghost-max2-orange-black-1104311d841",
  "brooks-ghost-max-3": "brooks-ghost-max-3-coconut-blue-heron-1204571b151",
  "brooks-glycerin-22": "brooks-mens-glycerin-22-white-grey-1104452e135",
  "brooks-glycerin-23": "brooks-glycerin-23-for-women",
  "brooks-glycerin-flex": "brooks-glycerin-flex-womens-white-peach",
  "brooks-glycerin-gts-23": "brooks-glycerin-gts-23-2e-wide-for-men",
  "brooks-glycerin-max": "brooks-glycerin-max-blue-heron-diva-pink-1204361b447",
  "brooks-glycerin-max-2": "brooks-glycerin-max-2-womens-oyster-argyle",
  "brooks-hyperion-elite-4": "brooks-unisex-hyperion-elite4-pb-bluewash-gecko-cobalt-1000531d134",
  "brooks-hyperion-elite-5": "mens-hyperion-elite-5-luminary-yellow-gray",
  "brooks-hyperion-elite-6": "brooks-hyperion-elite-6-unisex-grey-yellow",
  "brooks-hyperion-max-3": "hyperion-max-3-coconut-fiery-coral-atomizer-1204551b659",
  "brooks-launch-11": "brooks-women-launch-11-coral-primrose-white-1204391b603",
  "hoka-arahi-7": "hoka-womens-arahi7-bluespark-snowmelt-1147851-brks",
  "hoka-arahi-8": "hoka-arahi-8-wide-mens-varsity-navy-white",
  "hoka-bondi-9": "hoka-women-bondi-9-wide-mineral-blue-washed-blue-1162014-mblw",
  "hoka-cielo-x1-2": "hoka-cielox1-2-skyward-blue-cielo-blue-1162053-skyw",
  "hoka-cielo-x1-3": "hoka-men-cielo-x1-3-neonyuzu-thyme-1171927-nyz",
  "hoka-clifton-10": "hoka-women-clifton-10-birch-alabaster-1162031-bhlb",
  "hoka-clifton-11": "hoka-clifton-11-wide-for-women",
  "hoka-clifton-pro": "hoka-clifton-pro-wide-for-men",
  "hoka-gaviota-5": "hoka-gaviota-5-wide-alpine-blue-jadeite-1134270-alj",
  "hoka-gaviota-6": "hoka-gaviota-6-wide-womens-cosmic-grey-stardust",
  "hoka-mach-6": "hoka-women-mach-6-stucco-grout-1147810-sccg",
  "hoka-mach-7": "hoka-mach-7-womens-lilac-cream-tangerine-glow",
  "hoka-mach-x-2": "hoka-mach-x-2-grapefruit-electric-coral-1155119-gfrt",
  "hoka-mach-x-3": "hoka-machx3-white-neon-tangerine-1168720-wng",
  "hoka-rincon-4": "hoka-rincon-4-jadeite-alpine-blue-1155131-jtl",
  "hoka-rocket-x-3": "hoka-rocketx3-sunlight-neon-hoka-citrus-1168724-snlg",
  "hoka-speedgoat-6": "hoka-speedgoat-6-wide-greyskies-cosmicgrey-1147832-gmc",
  "hoka-speedgoat-7": "speedgoat-7-wide-berry-jam-starlight-glow",
  "mizuno-hyperwarp-elite": "mizuno-hyperwarp-elite-unisex-lava-orange-lightning-yellow",
  "mizuno-hyperwarp-pro": "mizuno-men-hyperwarp-pro-white-black-gold-j1gc267401",
  "mizuno-hyperwarp-pure": "mizuno-hyperwarp-pure-unisex-lava-orange-black",
  "mizuno-neo-vista-3": "mizuno-neo-vista-3-for-men",
  "mizuno-neo-zen-2": "mizuno-neo-zen-2-unisex-grey-orange",
  "mizuno-wave-rebellion-flash-3": "wave-rebellion-flash-3-white-silver-j1gc253681",
  "nb-1080-v14": "newbalance-mens-freshfoam-x-1080v14-2e-m108014s",
  "nb-1080-v15": "new-balance-infinion-1080v15-standard-b-for-women",
  "nb-860-v15": "new-balance-fresh-foam-x-860v15-wide-2e-mens-black-bayberry",
  "nb-880-v15": "new-balance-fresh-foam-x-880v15-d-for-women",
  "nb-balos-v1": "mens-fresh-foam-x-balos-v1-mbalce1",
  "nb-ellipse-v1": "new-balance-ellipse-v1-d-womens-linen-altitude-metallic",
  "nb-hierro-v9": "newbalance-mens-freshfoam-x-hierrov9-mthiero9",
  "nb-more-v5": "newbalance-womens-freshfoam-morev5-angora-wmorcf5",
  "nb-rebel-v4": "newbalance-womens-fuelcell-v4-hotmango-angora-wfcxcc4",
  "nb-rebel-v5": "new-balance-fuelcell-rebel-v5-b-for-women",
  "nb-sc-elite-v6": "new-balance-supercomp-elite-v6-b-womens-fresh-air-alkaline-green",
  "nb-sc-pacer-v2": "mens-newbalance-fuel-cell-supercomp-elite-pacer-v2-d-mfcrr16d",
  "nb-sc-rebel-v1": "new-balance-supercomp-rebel-v6-b-womens-sea-salt-neo-flame",
  "nike-acg-ultrafly-trail": "nike-acg-ultrafly-trail-for-men",
  "nike-alphafly-3": "nike-alphafly-3-womens-sail-crimsontint-fd8315-103",
  "nike-downshifter-13": "nike-men-downshifter-13-fd6454-016",
  "nike-downshifter-14": "nike-downshifter-14-mens-white-summit-white",
  "nike-invincible-3": "nike-invincible-3-womens-light-cream-coconut-milk-dr2660-201",
  "nike-maxfly-2": "nike-mens-air-zoom-maxfly-white-fd8395-102",
  "nike-metcon-10": "nike-metcon-10-for-women",
  "nike-pegasus-41": "nike-pegasus41-women-fd2723-001",
  "nike-pegasus-42": "nike-air-zoom-pegasus-42-wide-for-women",
  "nike-pegasus-easyon": "nike-mens-pegasus-easyon-black-fq7837-001",
  "nike-pegasus-plus": "nike-pegasus-plus-mens-volt-ice-volt-tint",
  "nike-pegasus-premium": "nike-pegasus-premium-womens-pink-smoke-light-magenta",
  "nike-pegasus-trail-5": "nike-pegasus-trail5-mens-khaki-dv3864-201",
  "nike-quest-6": "nike-mens-quest-6-game-royal-fd6033-405",
  "nike-revolution-8": "nike-revolution-8",
  "nike-rival-distance": "nike-zoom-rival-distance-citron-pulse-fz9653-800",
  "nike-rival-sprint": "nike-zoom-rival-sprint-citron-pulse-fz9663-800",
  "nike-streakfly-2": "nike-zoomx-streakfly-2-dark-obsidian-io9567-400",
  "nike-structure-25": "nike-structure-25-womens-black-white-dj7884-003",
  "nike-structure-26": "nike-structure-26-mens-white-atomic-pink",
  "nike-structure-plus": "nike-structure-plus-mens-blue-pink",
  "nike-superfly-elite-2": "nike-zoom-superfly-elite-2-for-men",
  "nike-vaporfly-3": "nike-mens-zoomx-vaporfly-next3-hv6351001",
  "nike-vaporfly-4": "nike-mens-zoomx-vaporfly-next-4-hf6414-001",
  "nike-victory-2": "nike-men-air-zoom-victory-citron-pulse-fd8411-800",
  "nike-vomero-18": "nike-vomero-18-womens-bleached-lilac-light-magenta",
  "nike-vomero-plus": "nike-women-vomero-plus-4-sail-hv8154-107",
  "nike-vomero-premium": "nike-vomero-premium-womens-pink-foam-pink-rise",
  "nike-winflo-11": "nike-womens-air-winflo-11-fj9510-001",
  "nike-zoom-rival-sprint-s9": "nike-zoom-rival-sprint-citron-pulse-fz9663-800",
  "nike-zoom-superfly-elite-2": "nike-zoom-superfly-elite-2-for-men",
  "nike-zoom-victory-2": "nike-men-air-zoom-victory-citron-pulse-fd8411-800",
  "nike-zoomfly-6": "zoom-fly-6",
  "on-cloud-6": "on-cloud-6-for-women",
  "on-cloud-x-4": "on-cloudx4-men-black-3me30040791",
  "on-cloud-x-5": "on-cloud-x-5-for-men",
  "on-cloudboom-strike": "cloudboom-strike-1-m-juniper-limelight-3me30484834",
  "on-cloudeclipse": "on-cloudeclipse-rock-lima-mens-3md300922551",
  "on-cloudflow-5": "on-cloudflow-5-womens-juniper-ice",
  "on-cloudmonster-2": "on-womens-cloudmonster-2-ivory-tangerine-3we10113202",
  "on-cloudmonster-3": "on-cloudmonster-3-womens-eclipse-ivory",
  "on-cloudmonster-hyper": "on-men-cloudmonster-hyper-fade-lime-3me10134323",
  "on-cloudrunner-3": "on-cloudrunner-3-mens-ivory-robin",
  "on-cloudsurfer-2": "on-cloudsurfer-2-mens-ivory",
  "on-cloudsurfer-max": "on-cloudsurfer-max-womens-white",
  "on-cloudsurfer-next": "on-cloudsurfer-next-mens-3me30020106",
  "on-cloudswift-4": "on-cloudswift-4-mens-ivory-wolf",
  "puma-darter-pro": "puma-unisex-darter-pro-black-white-31015201",
  "puma-deviate-elite-3": "puma-womens-deviate-nitro-elite3-mintmelt-speedblue-30981007",
  "puma-deviate-nitro": "puma-deviate-pure-nitro-shoes-for-women",
  "puma-deviate-nitro-3": "deviate-nitro-3-puma-black-puma-white-30970701",
  "puma-deviate-nitro-4": "puma-deviate-nitro-4-womens-sage-glow-moody-gray",
  "puma-deviate-nitro-elite-4": "deviatenitroelite4-men-freshwaterlemon-31212703",
  "puma-fast-r-nitro-elite-3": "puma-fast-r-nitro-elite-3-for-men",
  "puma-magmax-nitro-2": "magmax-nitro-2-puma-white-silver-mist-31212502",
  "puma-velocity-nitro-3": "velocity-nitro-3-hyrox-womens-puma-white-31141101",
  "puma-velocity-nitro-4": "puma-men-velocity-nitro4-green-terrain-31114010",
  "saucony-endorphin-azura": "saucony-endorphin-azura-for-men",
  "saucony-endorphin-elite-2": "saucony-endorphin-elite-2-white-vo2-s30994-343",
  "saucony-endorphin-elite-3": "saucony-endorphin-elite-3-for-men",
  "saucony-endorphin-pro-4": "saucony-women-endorphin-pro-4-coral-s10939-342",
  "saucony-endorphin-pro-5": "saucony-endorphin-pro-5-for-women",
  "saucony-endorphin-speed-4": "saucony-womens-endorphin-speed4-white-sunny-s10940-30",
  "saucony-endorphin-speed-5": "saucony-endorphin-speed-5-for-women",
  "saucony-guide-18": "saucony-men-guide-18-bone-s20998-227",
  "saucony-guide-19": "saucony-guide-19-for-women",
  "saucony-hurricane-25": "saucony-men-hurricane-25-white-frigid-s21026-343",
  "saucony-hurricane-26": "saucony-hurricane-26-womens-quartz-eggplant",
  "saucony-kinvara-15": "saucony-mens-kinvara15-cloud-cinder-s20967122",
  "saucony-ride-18": "saucony-men-ride-18-dove-navy-s21000-224",
  "saucony-triumph-22": "saucony-mens-triumph22-navy-dusk-s20964144",
  "saucony-triumph-23": "saucony-men-triumph-23-frigid-citron-s21023-343",
  "saucony-triumph-24": "saucony-triumph-24-for-women",
  "ua-infinite-elite": "underarmour-infinite-elite-3027189-107",
  "ua-velociti-elite-2": "ua-velociti-elite2-mens-3027205001",
  "ua-velociti-elite-3": "under-armour-velociti-elite-3-unisex-blue-fog-stone",
  "ua-velociti-spd": "under-armour-velociti-spd-mens-black-gray"
};
